export const ADD_TO_LIKE = 'ADD_TO_LIKE';
export const REMOVE_FROM_LIKE = 'REMOVE_FROM_LIKE';
export const CLEAR_LIKE = 'CLEAR_LIKE';